// extracted by mini-css-extract-plugin
module.exports = {"mobileAddDashboard":"_3qCeSnaK"};